










































































import { ConfirmModal, Pagination, Scrollbar, SvgImage } from '@/app/components';
import { useAxios, usePagination } from '@/app/composable';
import store from '@/app/store';
import { NotificationAPI } from '@/modules/notification/api';
import { NotificationOverview } from '@/modules/notification/components';
import { RefreshPageKeys } from '@/modules/notification/constants';
import { RefreshIcon } from '@vue-hero-icons/outline';
import { PropType, computed, defineComponent, onBeforeUnmount, ref } from '@vue/composition-api';
import { SelfBuildingSquareSpinner } from 'epic-spinners';

export default defineComponent({
    name: 'Notifications',
    components: {
        ConfirmModal,
        NotificationOverview,
        Pagination,
        RefreshIcon,
        Scrollbar,
        SelfBuildingSquareSpinner,
        SvgImage,
    },
    props: {
        // provided by the admin portal for the sortable table views, unused here
        query: {
            type: Object as PropType<{ sortBy: { field: string; asc: boolean } }>,
        },
    },
    setup(props, { root }) {
        const { exec, loading, error } = useAxios(true);

        const notifications = ref<any[]>([]);
        const unseenCount = ref<number>(0);
        const showMarkAllAsSeenModal = ref<boolean>(false);
        const { pagination, handleChangePage } = usePagination(root, { pageSize: 10 });

        const refresh = computed(() => store.state.notificationEngine.refresh[RefreshPageKeys.Notifications]);

        const enableMarkAllAsSeen = computed(() => unseenCount.value !== 0);

        const getNotifications = async () => {
            await exec(NotificationAPI.fetch(pagination.value.page, pagination.value.pageSize))
                .then((res: any) => {
                    notifications.value = res?.data.notifications;
                    pagination.value.total = res?.data.count;
                    unseenCount.value = res?.data.countUnseen;
                })
                .catch(() => {
                    notifications.value = [];
                    (root as any).$toastr.e('Getting Notification failed', 'Error');
                });
            store.dispatch.notificationEngine.disableRefreshAction(RefreshPageKeys.Notifications);
        };

        const changePage = (newPage: number) => {
            handleChangePage(newPage);
            getNotifications();
        };

        const destroy = async (id: number) => {
            await exec(NotificationAPI.delete(id))
                .then(() => {
                    store.commit.notificationEngine.DELETE_NOTIFICATION(id);
                    (root as any).$toastr.removeByType('success');
                    (root as any).$toastr.s('Notification deleted successfully', 'Success');

                    // if the last notification of the last page was deleted, step back a page
                    if (notifications.value.length === 1 && pagination.value.page > 1)
                        changePage(pagination.value.page - 1);
                    else getNotifications();
                })
                .catch(() => {
                    const errorMessage = error.value.response.data.message;
                    (root as any).$toastr.e(`Notification could not be deleted: ${errorMessage}`, 'Error');
                });
        };

        const markAsSeen = async (id: number) => {
            await store.dispatch.notificationEngine.changeSeenAt(id);
            getNotifications();
        };

        const markAllAsSeen = async () => {
            showMarkAllAsSeenModal.value = false;
            await store.dispatch.notificationEngine.markAllAsSeen();
            getNotifications();
        };

        onBeforeUnmount(() => {
            if (refresh.value) store.dispatch.notificationEngine.disableRefreshAction(RefreshPageKeys.Notifications);
        });

        getNotifications();

        return {
            loading,
            notifications,
            pagination,
            refresh,
            enableMarkAllAsSeen,
            showMarkAllAsSeenModal,
            getNotifications,
            changePage,
            destroy,
            markAsSeen,
            markAllAsSeen,
        };
    },
});
